// conf
import conf from 'conf/ajax';
// filters
import { questions_items, sort_by_items } from 'conf/filters';

const clone_object = (obj) => JSON.parse(JSON.stringify(obj));

const shallow_clone = (obj) => Object.assign({}, obj);

const is_function = (x) =>
{
    return Object.prototype.toString.call(x) === '[object Function]';
}

const after = (times, func) => 
{
    return function ()
    {
        if (--times < 1)
        {
            return func.apply(this, arguments);
        }
    };
};

const DEBUG_MSG = (msg, title = 'debug') =>
{
    console.log(`===== ${title} =====\n${msg}\n.`);
};

const query_builder_next = (obj, conf) =>
{
    const default_order_by = questions_items.meta.default;
    const default_sort_by = sort_by_items.meta.default;


    const sort_by_def = `&sort_by=${default_sort_by}`;
    const order_by_def = `&order_by=${default_order_by}`;
    const sort_order_def = '&sort_order=desc';
    const text = ((obj && obj.text) && obj.text !== '') ? `&text=${obj.text}` : '';
    // remove tags if is selected all
    const tags = (((obj && obj.filters) && ('tag' in obj.filters))
        && obj.filters.tag !== ''
        && obj.filters.tag.toUpperCase() !== 'ALL')
        ? `&tags=${obj.filters.tag}` : '';
    const sort_by = ((obj && obj.filters) && ('sort_by' in obj.filters) && (obj.filters.sort_by !== ''))
        ? `&sort_by=${obj.filters.sort_by}`
        : sort_by_def;
    const order_by = ((obj && obj.filters) && ('order_by' in obj.filters) && (obj.filters.order_by !== ''))
        ? `&order_by=${obj.filters.order_by}`
        : order_by_def;
    const cur_query = `?start_at=${obj.page.start}&end_at=${obj.page.stop}`;
    const uri = `${conf.plone_site}${conf.server.questions}${cur_query}${order_by}${text}${tags}${sort_order_def}${sort_by}`;
    return uri;
};

const page_builder_next = (obj, conf) =>
{
    const sort_order = '&sort_order=desc';
    const text = ((obj && obj.text) && obj.text !== '') ? `&text=${obj.text}` : '';
    // remove tags if is selected all
    const tags = (((obj && obj.filters) && ('tag' in obj.filters))
        && obj.filters.tag !== ''
        && obj.filters.tag.toUpperCase() !== 'ALL')
        ? `&tag=${obj.filters.tag}` : '';
    const sort_by = ((obj && obj.filters) && ('sort_by' in obj.filters) && (obj.filters.sort_by !== ''))
        ? `&sort_by=${obj.filters.sort_by}`
        : '';
    const order_by = ((obj && obj.filters) && ('order_by' in obj.filters) && (obj.filters.order_by !== ''))
        ? `&order_by=${obj.filters.order_by}`
        : '';
    //const cur_query = `?start_at=${obj.page.start}&end_at=${obj.page.stop}`;
    const cur_query = `?page=${obj.page}`
    const uri = `${conf.route.answer}${cur_query}${order_by}${text}${tags}${sort_order}${sort_by}`;
    return uri;
};

const get_page_reset = () =>
{
    const uri = `${conf.route.answer}`;
    return uri;
}

const page_params_parse = (_url) =>
{
    const url = new URL(_url);
    const page = url.searchParams.get("page");

    return (page === null) ?
        {
            start: 0,
            stop: 9
        }
        :
        {
            start: parseInt((page - 1) * conf.request.step, 10) || 0,
            stop: parseInt(page * conf.request.step, 10) - 1 || 0,
        };
};

const parse_params_from_url = (_url) =>
{
    const url = new URL(_url);
    const text = url.searchParams.get("text");
    const tag = url.searchParams.get("tag");
    const order_by = url.searchParams.get("order_by");
    const sort_by = url.searchParams.get("sort_by");
    const _pages = page_params_parse(url);

    // merge into default settings
    const params =
    {
        text: text || '',
        filters: {
            tag: tag || '',
            order_by: order_by || '',
            sort_by: sort_by || ''
        },
        page: _pages
    };
    return params;
};

const add_params_to_uri = (obj) =>
{
    function isString(x)
    {
        return Object.prototype.toString.call(x) === "[object String]"
    }
    let tmp = parse_params_from_url(window.location.href);
    if (obj.text && obj.text !== '' && isString(obj.text)) tmp.text = obj.text;
    if('text' in obj && obj.text === '') tmp.text = "";
    if (obj.filters && obj.filters.tag && obj.filters.tag !== '') tmp.filters.tag = obj.filters.tag;
    if (obj.filters && obj.filters.order_by && obj.filters.order_by !== '') tmp.filters.order_by = obj.filters.order_by;
    if (obj.filters && obj.filters.sort_by && obj.filters.sort_by !== '') tmp.filters.sort_by = obj.filters.sort_by;

    let _page = 1;
    if (obj.page && obj.page !== '' && obj.page !== 'reset')
    {
        _page = obj.page;
    }
    if (obj.page && obj.page !== '' && obj.page === 'reset')
    {
        _page = 1
    }
    if (obj?.page === null)
    {
        _page = 1;
    }
    if (_page !== null) tmp.page = _page;

    return {
        params: tmp,
        url: page_builder_next(tmp, conf)
    }
};

const tags_transformer =
{
    get_options_from_tags: (tags_data_from_srv) =>
    {
        let tmp = tags_data_from_srv;
        const all_tags = tmp.map(({ id, name }) => ({ id: id, value: id, label: name }));
        return all_tags
    }
};

const find_select_label_by_id = (id, data_set, def = 'ALL') =>
{
    const res = data_set.find(element => element.id === id);
    return (typeof (res) === "undefined") ? def :
        (res && res.label) ? res.label :
            def;
};

const react_select_add_value_field = (arr) =>
{
    return arr.map(({ id, label }) => ({ id: id, value: id, label: label }));
};

function* make_range_iterator(start = 0, end = Infinity, step = 1)
{
    let iterationCount = 0;
    for (let i = start; i < end; i += step)
    {
        iterationCount++;
        yield i;
    }
    return iterationCount;
};

export
{
    DEBUG_MSG,
    is_function,
    clone_object,
    shallow_clone,
    after,
    query_builder_next,
    page_params_parse,
    parse_params_from_url,
    tags_transformer,
    add_params_to_uri,
    find_select_label_by_id,
    react_select_add_value_field,
    get_page_reset,
    make_range_iterator
}